import { useEffect, useState } from "react";
import { listProductSets } from "../actions/productSetAction";
import { useDispatch, useSelector } from "react-redux";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";
import Slider from "react-slick"; // Import the slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md"; // Icons for next/prev arrows
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "./Loader";
import Message from "./Message";
import {
  useDisclosure,
} from "@chakra-ui/react";
import {
  addItemToWishlist,
  getWishlistItems,
  removeItemFromWishlist,
} from "../actions/wishListActions";
import { addItemToCart } from "../actions/cartActions";
import { FaRegEdit } from "react-icons/fa";
import { listSizes } from "../actions/sizeActions";
import { serverIp } from "../config/conf";
import axios from "axios";
import CartDrawer from "./CartDrawer";
import { ProductCard } from "../components/ProductSlider";


const getConfigurableProps = () => ({
  showArrows: true,
  showStatus: false,
  // showIndicators: true,
  infiniteLoop: true,
  showThumbs: false,
  useKeyboardArrows: true,
  autoPlay: true,
  stopOnHover: true,
  swipeable: true,
  dynamicHeight: true,
  emulateTouch: true,
  autoFocus: false,
  thumbWidth: 100,
  selectedItem: 0,
  interval: 2000,
  transitionTime: 800,
  swipeScrollTolerance: 5,
});

export default function Collections() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const notify = (link, content, type) =>
    type(<RouterLink to={link}>{content}</RouterLink>);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const productSetList = useSelector((state) => state.productSetList);
  const { loading, error, productSets } = productSetList;

  const wishList = useSelector((state) => state.wishlist);
  const { wishlistItems } = wishList;

  const sizeList = useSelector((state) => state.sizeList);
  const { loading: loadingSize, error: errorSize, sizes } = sizeList;

  const [qty, setQty] = useState(1);
  const [isBuyNow, setIsBuyNow] = useState(false);
  const [engravingTextMen, setEngravingTextMen] = useState(""); // State for engraving text
  const [engravingTextWomen, setEngravingTextWomen] = useState("");
  const [selectedPlating, setSelectedPlating] = useState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedSizeMen, setSelectedSizeMen] = useState(0);
  const [selectedSizeWomen, setSelectedSizeWomen] = useState(0);
  const [isCustomized, setIsCustomized] = useState(false);
  const [customQuestions, setCustomQuestions] = useState([]);
  const [userResponses, setUserResponses] = useState([]);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);
  const [backEng, setbackEng] = useState(""); // State for engraving text
  const [engImage, setengImage] = useState(""); // State for engraving text
  const [productSet, setProductSet] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItemBasePrice, setSelectedItemBasePrice] = useState([]);
  const [allowRingSize, setAllowRingSize] = useState(false);
  const [price, setPrice] = useState(0);
  const [basePrice, setBasePrice] = useState(0);


  const [allowAnkletType, setAllowAnkletType] = useState(false);
  const [allowBraceletSize, setAllowBraceletSize] = useState(false);
  const [selectedBraceletSizeMen, setSelectedBraceletSizeMen] = useState("");
  const [selectedBraceletSizeWomen, setSelectedBraceletSizeWomen] =
    useState("");
  const [isPair, setIsPair] = useState(false);

  const [selectedAnkletSize, setSelectedAnkletSize] = useState("");
  let [isAnkletSize, setIsAnkletSize] = useState(false)


  //********** For Pet *************//

  const [frontPetTexts, setFrontPetTexts] = useState([]);
  const [petTypesSelected, setPetTypesSelected] = useState([]);
  const [backPetTexts, setBackPetTexts] = useState([]);
  const [breedAge, setBreedAge] = useState([]);
  const [breedSize, setBreedSize] = useState([]);

  const handlePetFrontEngChange = (text, index) => {
    const updated = [...frontPetTexts];
    updated[index] = text;
    setFrontPetTexts(updated);
  };

  const handlePetTypeChange = (pet, index) => {
    const updated = [...petTypesSelected];
    updated[index] = pet;
    setPetTypesSelected(updated);
  };

  const handlePetBackEngChange = (text, index) => {
    const updated = [...backPetTexts];
    updated[index] = text;
    setBackPetTexts(updated);
  };

  const handleBreedAgeChange = (text, index) => {
    const updated = [...breedAge];
    updated[index] = text;
    setBreedAge(updated);
  };

  const handleBreedSizeChange = (text, index) => {
    const updated = [...breedSize];
    updated[index] = text;
    setBreedSize(updated);
  };

  useEffect(() => {
    // console.log("selectedProduct", selectedProduct);
    if (
      selectedProduct
      &&
      selectedProduct.productCollections?.some(cat => cat.name === "Pet Collection") &&
      selectedProduct.canEngrave && selectedProduct.canBackEng
    ) {
      const q = qty || 1;

      console.log("In Pet Collection Collection");

      setFrontPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setPetTypesSelected(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push(null);
        return updated.slice(0, q);
      });

      setBackPetTexts(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedAge(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });

      setBreedSize(prev => {
        const updated = [...prev];
        while (updated.length < q) updated.push('');
        return updated.slice(0, q);
      });
    }
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [qty]);


  useEffect(() => {
    dispatch(listProductSets());
    dispatch(getWishlistItems());
    dispatch(listSizes());
  }, [dispatch]);

  const settings1 = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 9000,
    pauseOnHover: true,
    prevArrow: <SamplePrevArrow />,
    nextArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const settings2 = {
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    // prevArrow: <SamplePrevArrow />,
    // nextArrow: <SampleNextArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleAddToCart = (obj) => {
    // e.preventDefault();
    const addToCart = () => {
      dispatch(addItemToCart(obj));
      // Check if the item exists in the wishlist
      const isInWishlist = wishlistItems?.some((item) => item._id === obj.product);

      if (isInWishlist) {
        dispatch(removeItemFromWishlist(obj.product));
      }
      onClose();
      if (isBuyNow) {
        setIsBuyNow(false);
        navigate("/cart");
      } else {
        notify("/cart", "Item Added To Cart", toast.success);
      }
    };

    // console.log("Select Product ---> ", selectedProduct);

    const categories = selectedProduct.categories?.map(c => c.name?.toLowerCase()) || [];
    const subcategories = selectedProduct.subcategories?.map(s => s.name?.toLowerCase()) || [];

    const isListString = (list) => {
      return Array.isArray(list) && list.every(item => typeof item === 'string');
    };

    const isRings = categories.includes("rings");
    const isBracelets = categories.includes("bracelets");
    const isAnklets = categories.includes("anklets");
    const isCoupleRing = subcategories.includes("couple rings");
    const isCoupleBracelets = subcategories.includes("for couples");
    const isSets = categories.includes("jewellery sets");
    const isMale = selectedProduct.gender?.toLowerCase() === "male";

    // const details = selectedProduct.product;

    if (isSets && productSet.length > 0 && productSet.length < 2) {
      notify("#", "Please Select Min 2 Items in Customized Set", toast.error);
      return;
    }

    if (isRings && isCoupleRing && (selectedSizeMen === 0 || selectedSizeWomen === 0)) {
      notify("#", "Select Both Ring Size", toast.error);
      return;
    }

    if (isRings && isMale && selectedSizeMen === 0) {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if ((isRings ||
      (isSets && productSet.length === 0) ||
      (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIR")))
    ) && !isMale && selectedSizeWomen === 0) {
      notify("#", "Select Ring Size", toast.error);
      return;
    }

    if (
      (isAnklets ||
        (isSets && productSet.length === 0 &&
          !isListString(selectedProductDetails) &&
          selectedProduct.products?.some(e => e.sku?.includes("SAIA"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIA")))
      ) && selectedAnkletSize === ""
    ) {
      notify("#", "Select Anklet Size", toast.error);
      return;
    }

    if (isBracelets && isCoupleBracelets && (selectedBraceletSizeWomen === "" || selectedBraceletSizeMen === "")) {
      notify("#", "Select Both Bracelets Size", toast.error);
      return false;
    }

    if (isBracelets && isMale && selectedBraceletSizeMen === "") {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (
      (isBracelets ||
        (isSets && productSet.length === 0 &&
          !isListString(selectedProductDetails) &&
          selectedProduct.products?.some(e => e.sku?.includes("SAIB"))) ||
        (isSets && productSet.length > 0 && selectedItems.some((item) => item.sku.includes("SAIB")))
      ) && !isMale && selectedBraceletSizeWomen === ""
    ) {
      notify("#", "Select Bracelets Size", toast.error);
      return false;
    }

    if (selectedProduct.canImgEng && selectedProduct.canBackEng) {
      if (petTypesSelected.includes(null) || petTypesSelected.length === 0 || petTypesSelected.includes('')) {
        notify("#", "Please Select Breed", toast.error);
        return;
      }

      if (breedSize.includes('')) {
        notify("#", "Please Select Size", toast.error);
        return;
      }

      if (breedAge.includes('')) {
        notify("#", "Please Select Your Pet Age", toast.error);
        return;
      }

      if (frontPetTexts.includes('')) {
        notify("#", "Enter Front Engraving Characters", toast.error);
        return;
      }

      if (backPetTexts.includes('')) {
        notify("#", "Enter Back Engraving Characters", toast.error);
        return;
      }
    }

    // All validations passed — add to cart
    addToCart();

  };

  const uploadImageHandler = async (e, setImageCallback) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);
    // setUploading(true);

    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await axios.post(
        `${serverIp}/api/uploads/single`,
        formData,
        config
      );

      // Use the passed callback to set the image URL
      setImageCallback(data);

      // setUploading(false);
    } catch (err) {
      console.error(err);
      // setUploading(false);
    }
  };

  const handleResponseChange = (index, event) => {
    const newResponses = [...userResponses];
    newResponses[index].answer = event.target.value;
    setUserResponses(newResponses);
  };

  const handleQuantityChange = (value) => {
    if (value >= 1 && value <= 5) {
      setQty(value);
    }
  };

  const handleEngravingInput = (value, gender) => {
    const lettersAndSpaces = /^[A-Za-z ]*$/; // Regex to allow only letters and spaces
    if (lettersAndSpaces.test(value)) {
      if (gender === "female" || gender === "unisex") {
        setEngravingTextWomen(value); // Update engraving text if input is valid
      } else {
        setEngravingTextMen(value); // Update engraving text if input is valid
      }
    }
  };

  const handleAccordionToggle = (isOpen) => {
    setIsAccordionOpen(isOpen); // Toggle Accordion state
    if (!isOpen) {
      setEngravingTextMen(""); // Clear engraving text when Accordion is closed
      setEngravingTextWomen(""); // Clear engraving text when Accordion is closed
    }
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const removeItemFromWishlistHandler = (id) => {
    dispatch(removeItemFromWishlist(id));
    notify("/wishlist", "Item Removed from Wishlist", toast.error);
  };

  const addItemToWishlistHandler = (productId) => {
    dispatch(addItemToWishlist(productId));
    notify("/wishlist", "Item Added To Wishlist", toast.success);
  };

  const totalPrice = selectedItems.reduce((sum, price) => sum + price, 0);

  const totalBasePrice = selectedItemBasePrice.reduce(
    (sum, price) => sum + price,
    0
  );

  const selectedProductDetails = {
    name: selectedProduct?.name,
    image:
      selectedProduct?.variants?.length > 0 &&
      selectedProduct?.variants?.filter((variant) =>
        selectedPlating.length > 0
          ? selectedPlating.includes(variant.color)
          : variant.isPrimary
      )[0]?.images[0],
    qty,
    sizeMen: selectedSizeMen,
    sizeWomen: selectedSizeWomen,
    price: productSet.length > 0 ? totalPrice : selectedProduct?.price,
    basePrice:
      productSet.length > 0 ? totalBasePrice : selectedProduct?.basePrice,

    product: selectedProduct?._id,
    products: productSet,
    variant:
      selectedProduct?.variants?.length > 0 &&
      selectedProduct?.variants?.filter((variant) => variant?.isPrimary)[0]
        ?._id,
    sku: selectedProduct?.sku,
    giftWrap: false,
    message: "",
    engraveMen: engravingTextMen,
    engraveWomen: engravingTextWomen,
    isPair: false,
    braceletsSizeMen:
      selectedBraceletSizeMen,
    braceletsSizeWomen:
      selectedBraceletSizeWomen,
    ankletsSize: selectedAnkletSize,
    petFrontEng: frontPetTexts,
    petBackEng: backPetTexts,
    petEngImage: petTypesSelected,
    breedAge: breedAge,
    breedSize: breedSize,
  };



  return (
    <div className="bg-[#F3F3FD]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <p className="text-center text-xl font-semibold py-10">
          MASTERPIECE BY SAIRAH
        </p>
        {loading ? (
          <Loader />
        ) : error ? (
          <Message type="error">{error}</Message>
        ) : (
          <div className="w-full min-h-[20vh] md:min-h-[70vh]">
            <Slider {...settings1}>
              {productSets.map((productSet, index) => (
                <div>
                  <div
                    key={index}
                    className="flex flex-col md:flex-row w-full items-center justify-center pb-10 gap-10"
                  >
                    <div className="flex items-center justify-center w-full md:w-1/2">
                      <div className="w-full">
                        {/* <Carousel {...getConfigurableProps()}> */}
                        <Slider {...settings2}>
                          {productSet?.products?.map((product, index) => (
                            // <div
                            //   key={index}
                            //   className="flex h-full flex-col justify-between relative p-2 group/prod"
                            // >
                            //   <RouterLink
                            //     className="w-1/2"
                            //     to={`/product/${product.name?.replaceAll(
                            //       " ",
                            //       "-"
                            //     )}/${product._id}?variant=${product?.variants?.length > 0 &&
                            //     product?.variants?.filter(
                            //       (variant) => variant.isPrimary
                            //     )[0]?._id
                            //       }`}
                            //   >
                            //     <div className="aspect-h-1 aspect-w-1 overflow-hidden bg-white">
                            //       {product?.variants?.length > 0 ? (
                            //         <img
                            //           src={
                            //             product?.variants?.length > 0 &&
                            //             product?.variants?.filter(
                            //               (variant) => variant.isPrimary
                            //             )[0]?.images[0]
                            //           }
                            //           alt={product?.name}
                            //           loading="lazy"
                            //           className={
                            //             "self-center hover:scale-125 transition-transform ease-in object-cover object-center m-auto bg-[#EBEAE5] text-center"
                            //           }
                            //         />
                            //       ) : (
                            //         <div className="flex h-full w-full bg-gray-100 items-center justify-center">
                            //           <span>Image</span>
                            //         </div>
                            //       )}
                            //     </div>
                            //     <h3 className="py-1 mt-3 text-center px-2 text-base font-semibold text-gray-800 h-6 overflow-clip truncate">
                            //       {product.name}
                            //     </h3>
                            //     <h3 className="py-1 mt-3 text-center px-2 text-[14px] text-gray-500 h-6 overflow-clip truncate">
                            //       {product.description}
                            //     </h3>
                            //     <div className="flex flex-col mt-3 px-2 gap-2 md:gap-4 justify-between items-center">
                            //       <div className="flex w-full items-center justify-center gap-1 md:gap-3 ">
                            //         {/* hidden group-hover/prod: */}
                            //         <p className="text-[14px] text-center text-gray-400 line-through">
                            //           ₹{" "}
                            //           {product.basePrice?.toLocaleString("en-IN")}
                            //         </p>
                            //         <p className="text-[14px] text-center md:text-base font-semibold text-[#000080]">
                            //           {(
                            //             ((product.basePrice - product.price) /
                            //               product.basePrice) *
                            //             100
                            //           ).toFixed(0)}
                            //           %
                            //         </p>
                            //       </div>
                            //       <div className="flex w-full items-center justify-center gap-1 md:gap-3">
                            //         <p className="text-sm text-center md:text-base font-bold text-gray-900">
                            //           ₹ {product.price?.toLocaleString("en-IN")}
                            //         </p>
                            //       </div>
                            //     </div>
                            //   </RouterLink>
                            //   <div className="w-full pt-2 bg-white block">
                            //     {/* hidden group-hover/prod: */}
                            //     <div className="flex justify-between items-center gap-1 h-[40px]">
                            //       {product?.categories?.some(
                            //         (cat) => cat.name === "Rings" ||
                            //           cat.name === "BRACELETS" ||
                            //           cat.name === "ANKLETS" ||
                            //           cat.name === "JEWELLERY SETS"
                            //       ) || product?.canEngrave ? (
                            //         <button
                            //           className="w-3/4 h-full bg-[#000080] rounded text-center self-center text-white text-sm font-medium"
                            //           onClick={() => {
                            //             if (userInfo && userInfo.firstName) {
                            //               onOpen();
                            //               setSelectedProduct(product);
                            //             } else {
                            //               navigate(
                            //                 `/signup?redirect=/product/${product.name?.replaceAll(
                            //                   " ",
                            //                   "-"
                            //                 )}/${product._id}?variant=${product?.variants?.length > 0 &&
                            //                 product?.variants?.filter(
                            //                   (variant) => variant.isPrimary
                            //                 )[0]?._id
                            //                 }`
                            //               );
                            //             }
                            //           }}
                            //         >
                            //           Add to Cart
                            //         </button>
                            //       ) : (
                            //         <button
                            //           className="w-3/4 h-full bg-[#000080] rounded text-center self-center text-white text-sm font-medium"
                            //           onClick={(e) => {
                            //             if (userInfo && userInfo.firstName) {
                            //               handleAddToCart(e, {
                            //                 name: product?.name,
                            //                 image:
                            //                   product?.variants?.length > 0 &&
                            //                   product?.variants?.filter(
                            //                     (variant) =>
                            //                       selectedPlating.length > 0
                            //                         ? selectedPlating.includes(
                            //                           variant.color
                            //                         )
                            //                         : variant.isPrimary
                            //                   )[0]?.images[0],
                            //                 qty,
                            //                 sizeMen: "1",
                            //                 sizeWomen: "1",
                            //                 price:
                            //                   productSet.length > 0
                            //                     ? totalPrice
                            //                     : product?.products?.some(
                            //                       (item) =>
                            //                         item.sku.includes("SAIA")
                            //                     )
                            //                       ? price
                            //                       : product.price,
                            //                 basePrice:
                            //                   productSet.length > 0
                            //                     ? totalBasePrice
                            //                     : product?.products?.some(
                            //                       (item) =>
                            //                         item.sku.includes("SAIA")
                            //                     )
                            //                       ? basePrice
                            //                       : product.basePrice,
                            //                 product: product._id,
                            //                 products: productSet,
                            //                 variant:
                            //                   product?.variants?.length > 0 &&
                            //                   product?.variants?.filter(
                            //                     (variant) => variant?.isPrimary
                            //                   )[0]?._id,
                            //                 sku: product?.sku,
                            //                 giftWrap: false,
                            //                 message: "",
                            //                 engraveMen: engravingTextMen,
                            //                 engraveWomen: engravingTextWomen,
                            //                 isPair,
                            //                 braceletsSizeMen:
                            //                   selectedBraceletSizeMen,
                            //                 braceletsSizeWomen:
                            //                   selectedBraceletSizeWomen,
                            //                 ankletsSize: selectedAnkletSize,
                            //                 petFrontEng: frontPetTexts,
                            //                 petBackEng: backPetTexts,
                            //                 petEngImage: petTypesSelected,
                            //                 breedAge: breedAge,
                            //                 breedSize: breedSize,
                            //               });
                            //             } else {
                            //               navigate(
                            //                 `/signup?redirect=/product/${product.name?.replaceAll(
                            //                   " ",
                            //                   "-"
                            //                 )}/${product._id}?variant=${product?.variants?.length > 0 &&
                            //                 product?.variants?.filter(
                            //                   (variant) => variant.isPrimary
                            //                 )[0]?._id
                            //                 }`
                            //               );
                            //             }
                            //           }}
                            //         >
                            //           Add to Cart
                            //         </button>
                            //       )}

                            //       <button
                            //         className="flex items-center justify-center w-1/4 h-full border border-[#000080] rounded"
                            //         onClick={() => {
                            //           wishlistItems?.some(
                            //             (item) => item._id === product._id
                            //           )
                            //             ? removeItemFromWishlistHandler(
                            //               product._id
                            //             )
                            //             : addItemToWishlistHandler(product._id);
                            //         }}
                            //       >
                            //         <Icon
                            //           as={
                            //             wishlistItems?.some(
                            //               (item) => item._id === product._id
                            //             )
                            //               ? AiFillHeart
                            //               : AiOutlineHeart
                            //           }
                            //           w="6"
                            //           h="6"
                            //           textColor="#000080"
                            //           cursor="pointer"
                            //         />
                            //       </button>
                            //     </div>
                            //   </div>
                            // </div>
                            <ProductCard
                              prod={product}
                              key={index}
                              setSelectedProduct={setSelectedProduct}
                              onOpen={onOpen}
                              setIsBuyNow={setIsBuyNow}
                              navigate={navigate}
                              userInfo={userInfo}
                              windowWidth={windowWidth} />
                          ))}
                        </Slider>
                      </div>
                    </div>

                    {/* Main Product Set Image Section */}
                    <div className="flex flex-col gap-4 items-center justify-center w-full">
                      <img
                        src={productSet.image} // Replace with the main product set image
                        alt="Main Product Set"
                        className="max-w-[90%]"
                        loading="lazy"
                      />
                      <h2 className="text-[18px] font-[700]">
                        {productSet.name}
                      </h2>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        )}

        <CartDrawer
          isOpen={isOpen}
          onClose={onClose}
          selectedProductDetails={selectedProductDetails}
          handleAddToCart={handleAddToCart}
          qty={qty}
          handleQuantityChange={handleQuantityChange}
          selectedProduct={selectedProduct}
          productSet={productSet}
          setProductSet={setProductSet}
          selectedPlating={selectedPlating}
          sizes={sizes}
          loadingSize={loadingSize}
          errorSize={errorSize}
          selectedSizeMen={selectedSizeMen}
          setSelectedSizeMen={setSelectedSizeMen}
          selectedSizeWomen={selectedSizeWomen}
          setSelectedSizeWomen={setSelectedSizeWomen}
          selectedAnkletSize={selectedAnkletSize}
          setSelectedAnkletSize={setSelectedAnkletSize}
          isPair={isPair}
          setIsPair={setIsPair}
          selectedBraceletSizeMen={selectedBraceletSizeMen}
          setSelectedBraceletSizeMen={setSelectedBraceletSizeMen}
          selectedBraceletSizeWomen={selectedBraceletSizeWomen}
          setSelectedBraceletSizeWomen={setSelectedBraceletSizeWomen}
          allowRingSize={allowRingSize}
          setAllowRingSize={setAllowRingSize}
          allowBraceletSize={allowBraceletSize}
          setAllowBraceletSize={setAllowBraceletSize}
          allowAnkletType={allowAnkletType}
          setAllowAnkletType={setAllowAnkletType}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          selectedItemBasePrice={selectedItemBasePrice}
          setSelectedItemBasePrice={setSelectedItemBasePrice}
          totalPrice={totalPrice}
          totalBasePrice={totalBasePrice}
          engravingTextMen={engravingTextMen}
          engravingTextWomen={engravingTextWomen}
          handleEngravingInput={handleEngravingInput}
          isAccordionOpen={isAccordionOpen}
          handleAccordionToggle={handleAccordionToggle}
          uploadImageHandler={uploadImageHandler}
          petTypesSelected={petTypesSelected}
          handlePetTypeChange={handlePetTypeChange}
          frontPetTexts={frontPetTexts}
          handlePetFrontEngChange={handlePetFrontEngChange}
          backPetTexts={backPetTexts}
          handlePetBackEngChange={handlePetBackEngChange}
          breedAge={breedAge}
          handleBreedAgeChange={handleBreedAgeChange}
          breedSize={breedSize}
          handleBreedSizeChange={handleBreedSizeChange}
        />

      </div>
    </div>
  );
}

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <MdNavigateNext
      className={className}
      style={{
        color: "gray",
        fontSize: "45px",
        height: "55px",
        width: "55px",
        paddingLeft: "20px",
      }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <MdNavigateBefore
      className={className}
      style={{
        color: "gray",
        fontSize: "45px",
        height: "55px",
        width: "55px",
        paddingRight: "20px",
      }}
      onClick={onClick}
    />
  );
}
